<template>
	<div class="overview">
		<div class="top">
			<span class="url">{{ details.url }}</span>
			<span class="time">更新于：{{ details.modifiedTime }}</span>
			<ig-icon name="shuaxinEmail" @click="refresh"></ig-icon>
		</div>
		<div class="tips">
			<div>近30天各大洲网站资源访问情况：</div>
		</div>
		<div class="bottom">
			<mapContainer :siteId="siteId"></mapContainer>
		</div>
	</div>
</template>

<script>
import skyProgress from '@/components/iglobalwin/formComponents/sky-progress.vue';
import mapContainer from './MapContainer.vue';

export default {
	name: 'overview',
	props: ['details','siteId'],
	components: {
		skyProgress,
		mapContainer,
	},
	methods: {
		toWebsiteAccessRecord() {
			this.$router.push({
				name: 'website_access_record',
			});
		},
		// 重新检测
		refresh() {
			this.$emit('refresh');
		},
	},
};
</script>

<style lang="scss" scoped>
.overview {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;

	.tips {
		display: flex;
		justify-content: space-between;
		padding: 10px 20px 0;
	}

	.top {
		padding: 20px 30px;
		background-color: #3da1ff;
		color: #ffffff;
		display: flex;
		align-items: center;

		.iconfont {
			font-size: 17px;
			cursor: pointer;
		}

		.url {
			font-size: 26px;
		}

		.time {
			font-size: 14px;
			margin: 0 20px;
		}
	}

	.bottom {
		display: flex;
		justify-content: center;

		.mapContainer {
			width: 60%;

			::v-deep .sky-charts {
				.el-card {
					box-shadow: none !important;
          border: none !important;
				}
			}
		}
	}
}
</style>
